import dynamic from "next/dynamic";

import { useShowAppBanner } from "./useShowAppBanner";

const AppBannerInner = dynamic(
  () => import("./AppBannerInner").then(module => module.AppBannerInner),
  { ssr: false }
);

/**
 * Whoppah's own install prompt, for mobile browsers other than Safari.
 *
 * It is the counterpart of `SmartAppBanner` in this folder, which emits the
 * `apple-itunes-app` meta that only Mobile Safari reads. `shouldShowAppBanner`
 * bails on Mobile Safari precisely so the two never render at once; without
 * that one condition an iPhone Safari visitor would see both.
 */
export const AppBanner = () => {
  const showBanner = useShowAppBanner();

  if (!showBanner) {
    return null;
  }

  return <AppBannerInner />;
};
